<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        
        <el-col :span="24">
					<el-form-item label="是否节点" prop="is_node">
						<el-radio-group v-model="form_data.is_node">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
        <el-col :span="24">
          <el-form-item label="选择场所类型" prop="type">
            <el-select v-model="form_data.type" placeholder="请选择" clearable>
              <el-option v-for="(item, index) in place_type_list" :key="index" :label="item.name" :value="item.id" v-show="item.name!='全部'"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item label="选择归属上级" prop="pid">
            
            <el-select @visible-change="func_click" v-model="form_data.pid" placeholder="请选择" clearable :disabled="form_data.is_node!=0">
              <el-option label="无" :value="0"></el-option>
              <el-option v-show="form_data.type!=''&&form_data.type==item.type" v-for="(item, index) in nodeList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="24">
          <el-form-item label="上级" prop="pid">
            <el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" clearable :disabled="form_data.is_node!=0"></el-cascader>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="行业名称" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        
      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>

export default {
  name: 'l-industry-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    },
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
    place_type_list(){
      return this.$store.state.list.place_type_list
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
          
        }
      }
    },
    "form_data.is_node"(val){
      if(val!=0){
        this.form_data.pid=0
      }
    },
    "form_data.type"(){
      if(!this.getdata_flag){
      this.form_data.pid=0
      }else{
        this.getdata_flag=false
      }
      this.changes();
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中

      //是否显示
      tree_node: [

      ],
      //表单数据
      form_data: {
        is_node:1,
        pid:0,
        name: '',
        type:''
        
      },
      nodeList:[],
      type_name:"",
      //表单验证规则
      rules: {
        industry_name: [
          { required: true, message: '内容不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },


  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    func_click(e){
      if(this.form_data.type=='' && e){
        this.$alert('请先选择场所类型', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    changes() {
      this.$_invoke("industry_getData", {
        type: this.form_data.type
      }).then((ret) => {
        this.nodeList = ret.data
      })
        .finally(() => {
          this.loading = false;
        });
    },
    
    //获取数据
    getData() {

      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`industry_updateData`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          // this.tree_node = ret.superior;
          this.getdata_flag=true
        }).finally(() => {
          this.loading = false;
        });

      } else {
        // this.form_data.use_type = this.$props.useType
      }
    },


    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {

        if (valid) {
          if(this.form_data.pid==""){
            this.form_data.pid=0
          }
          this.submitting = true;
          if (!this.hasId) {//添加
          // console.log(this.form_data)
          // console.log(typeof this.form_data.is_node)
          // console.log(typeof this.form_data.pid)
          // console.log(typeof this.form_data.type)
            this.$_invoke('industry_save', this.form_data).then(() => {
              this.$_msg.success('添加成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            this.$_invoke(`industry_update`, {
              id: this.$props.id,
              ...this.form_data
            }).then(() => {
              this.$_msg.success('修改成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
  },
}
</script>